import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "./ui/button";

// Previous / next with "Page x of y". Shown only when there is more than one page.
const Pagination = ({ page, limit, total, onPage }) => {
  const pages = Math.max(1, Math.ceil((Number(total) || 0) / limit));
  if (pages <= 1) return null;
  return (
    <nav aria-label="Pages" className="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-border-t tw-px-4 tw-py-3">
      <span className="tw-text-xs tw-text-muted-foreground">
        Page {page} of {pages} · {Number(total).toLocaleString("en-IN")} in all
      </span>
      <div className="tw-flex tw-gap-2">
        <Button size="sm" variant="outline" onClick={() => onPage(page - 1)} disabled={page <= 1}>
          <ChevronLeft aria-hidden="true" /> Previous
        </Button>
        <Button size="sm" variant="outline" onClick={() => onPage(page + 1)} disabled={page >= pages}>
          Next <ChevronRight aria-hidden="true" />
        </Button>
      </div>
    </nav>
  );
};

export default Pagination;
